import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const PhuxIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/phuxLogo.jpeg" style={style} />
}
